"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONProcessor = void 0;
const json_constants = require("@/client/components/create/json");
const Color_1 = require("@/common/Color");
const utils_1 = require("@/common/utils/utils");
function safeBoolean(val) {
    if (typeof val === 'boolean') {
        return val;
    }
    throw new Error(`${val} is not boolean`);
}
class JSONProcessor {
    constructor(model) {
        this.solarPhaseOption = false;
        this.bannedCards = [];
        this.includedCards = [];
        this.model = model;
        this.warnings = [];
    }
    applyJSON(json) {
        json = JSON.parse(JSON.stringify(json));
        const players = (0, utils_1.cast)(json['players'], (Array));
        const validationErrors = this.validatePlayers(players);
        if (validationErrors.length > 0) {
            throw new Error(validationErrors.join('\n'));
        }
        if (json.corporationsDraft !== undefined) {
            this.warnings.push('Corporations draft is no longer available. Future versions might just raise an error, so edit your JSON file.');
        }
        function initializeArrayFieldWithBackup(oldFieldName, newFieldName) {
            const oldValue = json[oldFieldName];
            const newValue = json[newFieldName];
            if (newValue === undefined || (0, utils_1.cast)(newValue, Array).length === 0) {
                json[newFieldName] = oldValue || [];
            }
        }
        initializeArrayFieldWithBackup(json_constants.OLD_CUSTOM_CORPORATIONS, json_constants.CUSTOM_CORPORATIONS);
        initializeArrayFieldWithBackup(json_constants.OLD_CUSTOM_COLONIES, json_constants.CUSTOM_COLONIES);
        initializeArrayFieldWithBackup(json_constants.OLD_BANNED_CARDS, json_constants.BANNED_CARDS);
        const ev = json.escapeVelocity;
        if (ev !== undefined && typeof ev === 'object') {
            json.escapeVelocityMode = true;
            json.escapeVelocityBonusSeconds = ev['bonusSectionsPerAction'];
            json.escapeVelocityPenalty = ev['penaltyVPPerPeriod'];
            json.escapeVelocityPeriod = ev['penaltyPeriodMinutes'];
            json.escapeVelocityThreshold = Number.parseInt(ev['thresholdMinutes'] ?? '');
        }
        function set(field) {
            return (0, utils_1.cast)(json[field] ?? [], Array);
        }
        this.bannedCards = set(json_constants.BANNED_CARDS);
        this.includedCards = set(json_constants.INCLUDED_CARDS);
        this.model.playersCount = players.length;
        this.model.showBannedCards = this.bannedCards.length > 0;
        this.model.showIncludedCards = this.includedCards.length > 0;
        const oldExpansionFields = {
            corpera: json_constants.CORPORATEERA,
            promo: json_constants.PROMOCARDSOPTION,
            venus: json_constants.VENUSNEXT,
            colonies: json_constants.COLONIES,
            prelude: json_constants.PRELUDE,
            prelude2: json_constants.PRELUDE2EXPANSION,
            turmoil: json_constants.TURMOIL,
            community: json_constants.COMMUNITYCARDSOPTION,
            ares: json_constants.ARESEXTENSION,
            moon: json_constants.MOONEXPANSION,
            pathfinders: json_constants.PATHFINDERSEXPANSION,
            ceo: json_constants.CEOEXTENSION,
            starwars: json_constants.STARWARSEXPANSION,
            underworld: json_constants.UNDERWORLDEXPANSION,
        };
        for (const expansion of Object.keys(oldExpansionFields)) {
            const x = oldExpansionFields[expansion];
            const val = json[x];
            if (typeof (val) === 'boolean') {
                this.model.expansions[expansion] = val;
            }
        }
        this.solarPhaseOption = safeBoolean(json.solarPhaseOption);
        const ignoredFields = [
            json_constants.OLD_BANNED_CARDS,
            json_constants.OLD_CUSTOM_COLONIES,
            json_constants.OLD_CUSTOM_CORPORATIONS,
            ...Object.values(oldExpansionFields),
            'escapeVelocity',
            'players',
            'solarPhaseOption',
            'constants'
        ];
        for (const k in json) {
            if (ignoredFields.includes(k)) {
                continue;
            }
            if (k in this.model) {
                this.model[k] = json[k];
            }
            else {
                this.warnings.push('Unknown property: ' + k);
            }
        }
        for (let i = 0; i < players.length; i++) {
            this.model.players[i] = players[i];
        }
    }
    validatePlayers(players) {
        const errors = [];
        const colors = new Set(players.map((p) => p.color));
        for (const color of colors) {
            if (Color_1.PLAYER_COLORS.indexOf(color) === -1) {
                errors.push(color + ' is not a color');
            }
        }
        if (colors.size !== players.length) {
            errors.push('Colors are duplicated');
        }
        return errors;
    }
}
exports.JSONProcessor = JSONProcessor;
